<template>
	<sa-page-layout :btnBackVisible="false" :btnNewVisible="true" :btnRefreshVisible="true" :linkedit="linkedit"
		:showModalLoading="showModalLoading" @refresh="onRefresh">
		<template slot="table-filter">
			<b-form @submit.prevent="onSubmit">
				<div class="sa-form-section sa-search-box">
					<b-row>
						<b-col xs="12" sm="12" md="3" lg="3" xl="3">
							<label class="sa-search-box-label">Struttura</label>
							<b-form-select v-model="filtroArticoliMagazzino.codiceAzienda" type="search"
								:options="strutturaOptions" value-field="codiceStruttura" text-field="denominazione"
								class="sa-search-input mb-2 mr-sm-2 mb-sm-0">
								<template #first>
									<b-form-select-option :value="null"> - Seleziona Struttura - </b-form-select-option>
								</template>
							</b-form-select>
						</b-col>
						<b-col xs="12" sm="12" md="3" lg="3" xl="3">
							<label class="sa-search-box-label">Magazzino</label>
							<b-form-select v-model="filtroArticoliMagazzino.magazzino" type="search"
								:options="magazzinoMagazziniOptions" text-field="descrizioneMagazzino" value-field="id"
								class="sa-search-input mb-2 mr-sm-2 mb-sm-0">
								<template #first>
									<b-form-select-option :value="null"> - Seleziona Magazzino - </b-form-select-option>
								</template>
							</b-form-select>
						</b-col>
						<b-col xs="12" sm="12" md="2" lg="3" xl="3">
							<label class="sa-search-box-label">Tipo</label>
							<b-form-select v-model="filtroArticoliMagazzino.codiceTipoArticolo" type="search"
								:options="tipoArticoloOptions" text-field="descrizioneTipoArticolo"
								value-field="codiceTipoArticolo" class="sa-search-input mb-2 mr-sm-2 mb-sm-0">
								<template #first>
									<b-form-select-option :value="null"> - Seleziona Tipo - </b-form-select-option>
								</template>
							</b-form-select>
						</b-col>
						<b-col xs="12" sm="12" md="3" lg="3" xl="3">
							<label class="sa-search-box-label">Nome</label>
							<div class="sa-search-search-wrapper">
								<input class="sa-search-box-input" v-model="filtroArticoliMagazzino.nomeArticolo"
									placeholder="Nome Articolo" />
								<!-- <button @click="onRicercaArticolo" class="sa-prescrizione-btn-search" title="Cerca">
                    <i class="fas fa-search"></i>
                  </button> -->
							</div>
						</b-col>
						<b-col xs="12" sm="12" md="3" lg="3" xl="3">
							<label class="sa-search-box-label">Codice Articolo</label>
							<div class="sa-search-search-wrapper">
								<input class="sa-search-box-input" v-model="filtroArticoliMagazzino.codiceArticolo"
									placeholder="Inserire codice Articolo" />
							</div>
						</b-col>
						<b-col xs="12" sm="12" md="3" lg="3" xl="3">
							<label class="sa-search-box-label">Codice Prodotto</label>
							<div class="sa-search-search-wrapper">
								<input class="sa-search-box-input" v-model="filtroArticoliMagazzino.codiceProdotto"
									placeholder="Inserire codice Prodotto" />
							</div>
						</b-col>
						<b-col xs="12" sm="12" md="3" lg="3" xl="3">
							<label class="sa-search-box-label">Codice Matricola/Lotto</label>
							<div class="sa-search-search-wrapper">
								<input class="sa-search-box-input" v-model="filtroArticoliMagazzino.lottoMatricola"
									placeholder="Inserire LottoMatricola" />
							</div>
						</b-col>
						<b-col xs="12" sm="12" md="3" lg="3" xl="3">
							<label class="sa-search-box-label">Stato</label>
							<b-form-select v-model="filtroArticoliMagazzino.stato" :options="statiOptions"
								value-field="value" text-field="text" class="sa-search-input mb-2 mr-sm-2 mb-sm-0">
								<template #first>
									<b-form-select-option :value="null"> - Seleziona Stato - </b-form-select-option>
								</template>
							</b-form-select>
						</b-col>
					</b-row>
					<b-row style="margin-top: 5px">
						<b-col class="sa-padding-right text-right mb-3">
							<b-button type="submit" variant="info">{{ this.$i18n.t("global.lblFind") }}</b-button>
							<b-button type="reset" v-on:click="onReset" variant="danger">{{
								this.$i18n.t("patients.lblResetFilter")
							}}</b-button>
						</b-col>
					</b-row>
				</div>
			</b-form>
		</template>
		<template slot="table-body">
			<magazzino-articoli-list-component ref="cmpMagazzinoArticoliListComponent"
				@beforeLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData" @updateFilter="onUpdateFilter" />
		</template>
	</sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import UtilityMixin from "../../utility/UtilityMixin";
import MagazzinoArticoliListComponent from "../components/MagazzinoArticoliListComponent.vue";
import MagazzinoMixins from "../mixins/MagazzinoMixins";
import StruttureMixin from "../../strutture/mixins/StruttureMixin";
export default {
	name: "MagazzinoArticoliListPage",
	mixins: [MagazzinoMixins, StruttureMixin],
	components: { SaPageLayout, MagazzinoArticoliListComponent },
	data() {
		return {
			showModalLoading: false,
			linkedit: "articoli",
			filtroArticoliMagazzino: { nomeArticolo: null, stato: null, codiceTipoArticolo: null, magazzino: null, struttura: null },
			statiOptions: [
				{ text: "ATTIVO", value: "ATTIVO" },
				{ text: "CANCELLATO", value: "CANCELLATO" },
			],
			tipoArticoloOptions: [{ codiceTipoArticolo: null, descrizioneTipoArticolo: null }],
			pathResourceTipiArticolo: "/magazzinoarticolitipo",
		};
	},
	watch: {
		"filtroArticoliMagazzino.codiceAzienda": function (params) {
			let filtro = {
				codiceStruttura: params,
			};
			this.magazzinoMagazziniLoadData(filtro);
		},
	},
	mounted() {
		// let me = this;
		// me.$refs.cmpGestioneAttivitaProgettiListComponent.init(me.filtroArticoliMagazzino);
		// me.loadStati();
		let me = this;
		me.loadDefaultData();
		me.loadDataArticoli();
		me.loadDataTipoArticolo();
	},

	methods: {
		loadDefaultData() {
			this.struttureLoadData();
		},
		loadDataArticoli() {
			let me = this;
			me.$refs.cmpMagazzinoArticoliListComponent.loadDataArticoli();
		},
		loadDataTipoArticolo() {
			let me = this;
			UtilityMixin.methods.loadDataResources(me.pathResourceTipiArticolo, {}, me.loadDataTipoArticoloSuccess, me.loadDataTipoArticoloError);
		},
		loadDataTipoArticoloSuccess(response) {
			let me = this;
			me.tipoArticoloOptions = response.data.data.list;
			// me.tipoArticoloOptions.unshift({ codiceTipoArticolo: null, descrizioneTipoArticolo: "- Seleziona Articolo -" });
		},
		loadDataTipoArticoloError(error) {
			console.log(error);
		},
		onBeforeLoadData() {
			let me = this;
			me.showModalLoading = true;
		},
		onAfterLoadData() {
			let me = this;
			me.showModalLoading = false;
		},
		onRefresh() {
			let me = this;
			me.loadDataArticoli();
		},
		onSubmit() {
			let me = this;
			let sessionStorage = window.sessionStorage;

			sessionStorage["filtroMagazzino"] = JSON.stringify(me.filtroArticoliMagazzino);

			me.loadDataArticoli();
		},
		onReset() {
			let me = this;
			me.filtroArticoliMagazzino = { nomeArticolo: null, stato: null, codiceTipoArticolo: null, magazzino: null, struttura: null };
			// console.log("filtro in page: ", this.filtroArticoliMagazzino);

			let sessionStorage = window.sessionStorage;
			sessionStorage["filtroMagazzino"] = JSON.stringify(me.filtroArticoliMagazzino);
			me.loadDataArticoli();
		},
		onUpdateFilter(filterData) {
			let me = this;
			// console.log("filtro", filterData);

			me.filtroArticoliMagazzino = filterData;
		},
	},
};
</script>

<style></style>
